import * as React from 'react';
import Button from 'antd/lib/button';
import Divider from 'antd/lib/divider';
import Space from 'antd/lib/space';
import Typography from 'antd/lib/typography';
import { TimelineEventIssueTrackingTicketsTransitionedToStatusData } from '@/types/timelineEvents';
import { antGrey, runwayColors } from '../styles/globalStyles';

const { Text } = Typography;

export const VISIBLE_TRANSITIONED_TICKETS_COUNT = 5;

export const TransitionedTicketsList: React.FC<{
    data: TimelineEventIssueTrackingTicketsTransitionedToStatusData;
    isFailure: boolean;
}> = ({ data, isFailure }) => {
    const [isExpanded, setIsExpanded] = React.useState(false);
    const tickets = data?.tickets ?? [];
    if (tickets.length === 0) {
        return null;
    }

    const visibleTickets = isExpanded ? tickets : tickets.slice(0, VISIBLE_TRANSITIONED_TICKETS_COUNT);
    const hiddenTicketsCount = tickets.length - VISIBLE_TRANSITIONED_TICKETS_COUNT;
    const ticketsLabel = `${tickets.length} ticket${tickets.length === 1 ? '' : 's'}`;

    return (
        <div style={{ marginTop: 12 }}>
            <Text
                style={{
                    display: 'block',
                    fontSize: '12px',
                    color: antGrey.grey7,
                    letterSpacing: '0.1em',
                    textTransform: 'uppercase',
                    fontWeight: 400,
                    marginLeft: 5,
                    marginBottom: 8,
                }}
            >
                {isFailure ? 'Failed to update to' : 'Updated to'} {data.status} · {ticketsLabel}
            </Text>
            <div
                style={{
                    backgroundColor: antGrey.grey2,
                    borderRadius: '8px',
                    border: `1px solid ${antGrey.grey5}`,
                }}
            >
                <Space
                    direction="vertical"
                    size={0}
                    style={{ width: '100%' }}
                    split={<Divider style={{ backgroundColor: antGrey.grey5, margin: 0, width: '100%' }} />}
                >
                    {visibleTickets.map((ticket) => {
                        const displayKey = ticket.displayKey || ticket.key;
                        return (
                            <div key={ticket.key} style={{ padding: '6px 10px' }}>
                                <div style={{ display: 'flex', alignItems: 'baseline', gap: 8, minWidth: 0 }}>
                                    {ticket.url ?
                                        <Typography.Link
                                            href={ticket.url}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{ whiteSpace: 'nowrap' }}
                                        >
                                            {displayKey}
                                        </Typography.Link>
                                    :   <Text style={{ whiteSpace: 'nowrap' }}>{displayKey}</Text>}
                                    {ticket.title && (
                                        <Text
                                            type="secondary"
                                            ellipsis={{ tooltip: ticket.title }}
                                            style={{ color: antGrey.grey8, flex: 1, minWidth: 0 }}
                                        >
                                            {ticket.title}
                                        </Text>
                                    )}
                                </div>
                                {ticket.failureReason && (
                                    <Text style={{ display: 'block', fontSize: 12, color: runwayColors.statusRed }}>
                                        {ticket.failureReason}
                                    </Text>
                                )}
                            </div>
                        );
                    })}
                </Space>
            </div>
            {hiddenTicketsCount > 0 && (
                <Button type="link" size="small" style={{ paddingLeft: 5 }} onClick={() => setIsExpanded(!isExpanded)}>
                    {isExpanded ? 'Show less' : `Show ${hiddenTicketsCount} more`}
                </Button>
            )}
        </div>
    );
};
